import { useEffect } from 'react';
import { getCurrentAppType } from 'utils/dynamicConfig';

export const useDocumentTitle = () => {
  useEffect(() => {
    const appType = getCurrentAppType();
    const isOpsDomain = appType.includes('ops');
    const title = isOpsDomain ? 'Pharo Ops Tools' : 'Pharo OMS';
    document.title = title;
  }, []);
}; 